import { makeStyles, type Theme } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles<Theme>(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(3),
      padding: theme.spacing(2),
      background: COLORS.gray.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,

      '&:focus-visible': {
        outline: 'auto',
        outlineColor: COLORS.primary.default,
      },

      '& svg': {
        fontSize: theme.typography.pxToRem(36),
        color: COLORS.gray.gray50,
      },
    },
    title: {
      color: COLORS.gray.gray40,
    },
    button: {},
  }),
  { name: 'SelectFileArea' }
);
